import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const ShippingText = styled(TextBase)`
  font-weight: 700;
`;
